import { render, staticRenderFns } from "./ConfigIndividualTuitionFeeAddEditDialog.vue?vue&type=template&id=3349830e&scoped=true"
import script from "./ConfigIndividualTuitionFeeAddEditDialog.vue?vue&type=script&lang=js"
export * from "./ConfigIndividualTuitionFeeAddEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfigIndividualTuitionFeeAddEditDialog.vue?vue&type=style&index=0&id=3349830e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349830e",
  null
  
)

export default component.exports